import { render, staticRenderFns } from "./EmbedNuggets.vue?vue&type=template&id=6964b5a8&scoped=true"
import script from "./EmbedNuggets.vue?vue&type=script&lang=js"
export * from "./EmbedNuggets.vue?vue&type=script&lang=js"
import style0 from "./EmbedNuggets.vue?vue&type=style&index=0&id=6964b5a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6964b5a8",
  null
  
)

export default component.exports